import type { ComponentProps, RefObject } from "react";
import { Portal, Select } from "@ark-ui/react";
import clsx from "clsx";
import type { PanelWidth } from "@base/ui/Selector/types";

type Props = ComponentProps<typeof Select.ItemGroup> & {
  width?: PanelWidth;
  className?: string;
  container?: RefObject<HTMLElement>;
  usePortal?: boolean;
};

const Content = ({ children, width = "anchor", className, container, usePortal = true, ...rest }: Props) => {
  return (
    <Portal container={container} disabled={!usePortal}>
      <Select.Positioner
        style={{
          width: width === "anchor" ? "var(--reference-width)" : width,
        }}
      >
        <Select.Content
          className={clsx(
            "bg-white shadow-xs focus-visible:outline-none rounded-6 [&:is([closed],[data-closed],[data-state=closed])]:animate-fadeOut [&:is([open],[data-open],[data-state=open])]:animate-fadeIn",
            className,
          )}
        >
          <Select.ItemGroup {...rest}>{children}</Select.ItemGroup>
        </Select.Content>
      </Select.Positioner>
    </Portal>
  );
};

export default Content;
